/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedSendToFriendModalLazy_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AuthShareModal_viewer">;
    readonly " $refType": "PdpSharedSendToFriendModalLazy_viewer";
};
export type PdpSharedSendToFriendModalLazy_viewer$data = PdpSharedSendToFriendModalLazy_viewer;
export type PdpSharedSendToFriendModalLazy_viewer$key = {
    readonly " $data"?: PdpSharedSendToFriendModalLazy_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSendToFriendModalLazy_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSendToFriendModalLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthShareModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7680aaf2b52f43693fd300127ebf3017';
export default node;
